"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListFilterItemBoolean = void 0;
const ProductListFilterItem_1 = require("./ProductListFilterItem");
class ProductListFilterItemBoolean extends ProductListFilterItem_1.ProductListFilterItem {
    constructor(filterItemData) {
        super(filterItemData);
        this._value = this.getValueFromResult(filterItemData);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }
    get paramValue() {
        if (this.value !== undefined) {
            return this.value ? ProductListFilterItemBoolean.trueValueId : ProductListFilterItemBoolean.falseValueId;
        }
        return "";
    }
    clear() {
        this._value = undefined;
    }
    getValueFromResult(filterItemData) {
        var _a;
        if (filterItemData.values.length > 1) {
            return undefined;
        }
        return ((_a = filterItemData.values[0]) === null || _a === void 0 ? void 0 : _a.id) === ProductListFilterItemBoolean.trueValueId;
    }
    applyFilterItemResult(filterItemData) {
        this._value = this.getValueFromResult(filterItemData);
    }
}
exports.ProductListFilterItemBoolean = ProductListFilterItemBoolean;
ProductListFilterItemBoolean.trueValueId = "true";
ProductListFilterItemBoolean.falseValueId = "false";
